<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="Master Partner">
      <!-- <b-card-text>Partner.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Partner -->
            <b-col cols="12">
              <b-form-group label="Partner" label-for="v-Partner">
                <validation-provider #default="{ errors }"  name="Partner">
                  <v-select id="v-Partner" v-model="form.select_1" placeholder="Chose Partner" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="partnerOptions" :reduce="partnerOptions => partnerOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Prefix -->
            <b-col cols="12">
              <b-form-group label="Prefix" label-for="v-Prefix">
                <validation-provider #default="{ errors }"  name="Prefix" rules="required">
                  <b-form-input  id="v-Prefix" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Prefix" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Name -->
            <b-col cols="12">
              <b-form-group label="Name" label-for="v-Name">
                <validation-provider #default="{ errors }"  name="Name" rules="required">
                  <b-form-input  id="v-Name" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Name" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Address -->
            <b-col cols="12">
              <b-form-group label="Address" label-for="v-Address">
                <validation-provider #default="{ errors }"  name="Address" rules="required">
                  <b-form-input  id="v-Address" :state="errors.length > 0 ? false:null" v-model="form.text_3" placeholder="Address" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- media -->
            <b-col cols="12">
              <b-media no-body>
                <b-media-aside>
                  <b-link>
                    <b-img
                      ref="previewEl"
                      rounded
                      :src="form.imageUrl"
                      height="60"
                    />
                  </b-link>
                  <!--/ avatar -->
                </b-media-aside>

                <b-media-body class="mt-75 ml-75">
                  <!-- upload button -->
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    size="sm"
                    class="mb-75 mr-75"
                    @click="$refs.refInputEl.$el.click()"
                  >
                    Upload
                  </b-button>
                  <b-form-file
                    ref="refInputEl"
                    v-model="form.logo"
                    accept=".jpg, .png, .gif"
                    :hidden="true"
                    plain
                    @change="inputImageRenderer"
                  />
                  <!--/ upload button -->

                  <!-- reset -->
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="outline-secondary"
                    size="sm"
                    class="mb-75 mr-75"
                  >
                    Reset
                  </b-button>
                  <!--/ reset -->
                  <b-card-text>Allowed JPG or PNG. Max size of 2000kB</b-card-text>
                </b-media-body>
              </b-media>
            </b-col>
            <!--/ media -->
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BCol, BFormGroup, BFormCheckbox,  BFormInput, BForm, BButton, BCard,  BImg} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BFormCheckbox,  ValidationProvider, ValidationObserver, BCard, BImg, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, select_4: '', text_1: '',text_2: '', text_3: '', imageUrl: require('@/assets/images/icons/jpg.png'), setImage: 'none', logo: null},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ partnerOptions: state => state.partner.options})
  },
  created () {
    this.$store.dispatch('partner/getAll')
  },
  watch: {
    select_1 (obj) {
      return this.$store.dispatch('partner/getAll', obj)
		},
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('company/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('company/getById', id).then(data => {
        this.form.id = data.id
        this.form.text_1 = data.prefix
        this.form.text_2 = data.name
        this.form.text_3 = data.address
        this.form.select_4 = data.partner_id
        this.form.imageUrl = data.logo
        this.show = false
      })
    },
    inputImageRenderer (e) {
			const file = e.target.files[0]
			this.form.logo = file
			this.form.setImage = 'upload'
			this.form.imageUrl = URL.createObjectURL(e.target.files[0])
		}
  },
  mounted () {
    this.$store.dispatch('partner/getAll')
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>